<div class="row header-contract no-gutters" [ngClass]="{'mt-0': isApp}">
    <div *edpConditionalRegion="'pt.edp.edponline.header.contract.offer'">
        <div class="col-4 col-lg separator" *ngIf="contract?.isInactive()">
            <div class="d-flex h-100 p-3 align-items-center">
                <div class="m-auto">
                    <span class="d-block title">{{ "pt.edp.edponline.contract.inactive_place" | translate}}</span>
                </div>
            </div>
        </div>
        <div class="col-8 col-lg separator"
            [ngClass]="{'col-12': !contract?.HasPack && !isElegiblePack && !contract?.isInactive()}">
            <edp-header-contract-offer [contractSelected]="contract">
            </edp-header-contract-offer>
        </div>
    </div>
    <div *edpConditionalRegion="'pt.edp.edponline.header.contract.pack'">
        <div class="col-4 col-lg-5 col-xl separator" *ngIf="contract?.HasPack">
            <edp-header-pack [contractSelected]="contract"></edp-header-pack>
        </div>
    </div>
    <div class="col-4 col-lg separator" *ngIf="isElegiblePack">
        <div class="d-flex h-100 p-3 align-items-center">
            <div class="my-auto ml-auto">
                <span class="title">{{ "pt.edp.edponline.contract.header.pack" | translate }}</span>
            </div>
            <div class="my-auto mr-auto">
                <a [routerLink]="['/novo-plano']">
                    <span class="d-inline-block align-middle ml-2">
                        <i class="icon-edponline-Bop-073 rotate-270 icon-size" aria-hidden="true"></i>
                    </span>
                </a>
            </div>
        </div>
    </div>
</div>